
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Emit, Prop } from "vue-property-decorator";
    import CutieCardImagePart from "@/app/components/cutie/cards/CutieCardImagePart.vue";
    import type { CutieListAllEntry } from "@/app/cuties/list/CutieListApiService";
    import CutieCardStats from "@/app/components/cutie/cards/CutieCardStats.vue";
    import CutieCardMetaDetailsLine from "@/app/components/cutie/cards/CutieCardMetaDetailsLine.vue";
    import CutieCardNameLine from "@/app/components/cutie/cards/CutieCardNameLine.vue";

    /** the new age _Marketplace -> For Sale_ page */
    @Component({
        components: { CutieCardImagePart, CutieCardStats, CutieCardMetaDetailsLine, CutieCardNameLine },
    })
    export default class CutieListAllContents extends Vue {
        @Prop({ required: true }) cuties: CutieListAllEntry[];
        @Prop({ default: true }) showStats: boolean;

        @Emit()
        select(cutie: CutieListAllEntry) {
            return cutie;
        }
    }
